
import React from 'react';
import { primaryColor, primaryFont, primaryHeadingColor, secondaryFont, wMBold, wMedium } from 'constants/utilsStyles';
import { Typography } from 'antd';
import styled from 'styled-components';
import ContactWidget from './ContactWidget';
import { IContactItem } from 'modules/Audience/interface';

const { Paragraph } = Typography;

const ContactInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .contact-widget-wrapper {
    margin-bottom: 0px;
  }
  .textual-area {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    width: calc(100% - 80px);
    .contact-name {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 21px;
      line-height: 24px;
      color: ${primaryHeadingColor};
      margin-bottom: 0px;
    }
    .contact-text {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 14px;
      line-height: 16px;
      color: ${primaryHeadingColor};
      &.org {
        margin-bottom: 0px;      
      }
      &.gmail {
        color: ${primaryColor};
        margin-bottom: 1px;
      }
    }
  }
`;

type Props = {
  contact: IContactItem,
} & typeof defaultProps;

const defaultProps = {
};

const ContactInfoCard = function ContactInfoCard(props: Props) {
  const { contact } = props;
  const { contactName, designation, contactEmail } = contact;
  return (
    <ContactInfoWrapper className='contact-info-wrapper'>
      <ContactWidget diameter="58px" diameterL='60px' ringPadding="2px" contact={contact} />
      <div className='textual-area'>
        <Paragraph className='contact-name text-truncate' ellipsis={{ rows: 1, tooltip: contactName }}>{contactName}</Paragraph>
        <Paragraph className='contact-text gmail text-truncate' ellipsis={{ rows: 1, tooltip: contactEmail }}>{contactEmail}</Paragraph>
        <Paragraph className='contact-text org text-truncate' ellipsis={{ rows: 1, tooltip: designation }}>{designation}</Paragraph>
      </div>
    </ContactInfoWrapper>
  );
};
ContactInfoCard.defaultProps = defaultProps;
export default ContactInfoCard;